import { useState, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getAvailableSeasons } from '../../actions/contentActions'
import { useAppDispatch, useAppSelector } from '../../hooks/useStore'
import { ComcastErrorType, getQueryParam } from '../../../../shared/helpers'

import type { Season } from '../../reducers/types/reducerTypes'
import type { SeasonsParams, SeasonType } from './types'

const useSeasons = (): SeasonsParams => {
  const stationId = useAppSelector((state) => state.station.station_id)
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const season = getQueryParam(location.search, 'season') || undefined
  const type = (getQueryParam(location.search, 'type') ||
    undefined) as SeasonType
  const showTitle = getQueryParam(location.search, 'parent') || undefined
  const { show: slug } = useParams()
  const [seasons, setSeasons] = useState<Season[]>([])
  const [activeSeason, setActiveSeason] = useState<Season>()
  const [seasonsLoaded, setSeasonsLoaded] = useState<boolean>(false)

  useEffect(() => {
    getAvailableSeasons(slug, stationId)
      .then((resp) => {
        const seasons: Season[] = resp.collections[0].content.filter(
          (season) => season.flags.has_assets || season.flags.has_episodes
        )
        setActiveSeason(
          seasons.find((s) => s.ordinal?.toString() === season) || seasons[0]
        )
        setSeasonsLoaded(true)
        setSeasons(seasons)
      })
      .catch((error) => {
        dispatch({
          type: 'TRIGGER_ERROR',
          payload: {
            error: {
              content: {
                error,
                errorPath: location.pathname,
              },
              codeBaseLocation: 'useSeasons - useEffect',
              errorType: ComcastErrorType.network,
            },
          },
        })

        navigate('/error', { replace: true })
      })
  }, [])

  return {
    seasons,
    activeSeason,
    setActiveSeason,
    seasonsLoaded,
    showTitle,
    seasonType: type,
  }
}

export default useSeasons
